import type { ThinkingLevel } from "@apholdings/jensen-agent-core";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "medium";
